const subscribersMap = new Map()
const delaySubscribersMap = new Map()

let timeout = null

export const dga = {
  websocket: null,
  wsUri: null,
  tableId: null,
  casinoId: null,
  tryToConnect: true,
  availableTables: null,
  currency: null,

  // public
  connect: function (wsUri, casinoId, currency) {
    const self = this
    self.tryToConnect = true
    self.wsUri = wsUri
    self.currency = currency
    if (self.websocket !== null && ![2, 3].includes(self.websocket.readyState)) {
      self.tryToConnect === false
      self.websocket.close()
    }
    self.websocket = new WebSocket('wss://' + wsUri + '/ws')
    self.websocket.onopen = function (evt) {
      self.onWsOpen(evt, casinoId)
    }
    self.websocket.onclose = function (evt) {
      self.onWsClose(evt)
    }
    self.websocket.onmessage = function (evt) {
      self.onWsMessage(evt)
    }
    self.websocket.onerror = function (evt) {
      self.onWsError(evt)
    }
    self.casinoId = casinoId
  },
  // public
  onMessage: function (data) {
    const id = data.tableId

    if (data.tableKey) {
      this.availableTables = data.tableKey

      for (let tableId of delaySubscribersMap.keys()) {
        if (this.availableTables) {
          if (this.availableTables.includes(tableId)) {
            this.subscribe(tableId, delaySubscribersMap.get(tableId))
            delaySubscribersMap.delete(tableId)
          }
        }
      }
    }

    if (subscribersMap.has(id) && typeof subscribersMap.get(id) === 'function') {
      subscribersMap.get(id)(data)
    }
  },
  // public
  onConnect: function () {
    this.available(this.casinoId)
  },
  // public
  disconnect: function () {
    const self = this
    self.tryToConnect = false
    self.websocket.close()
    this.availableTables = null
  },
  // public
  subscribe: function (tableId, callback) {
    const subscribeMessage = {
      type: 'subscribe',
      key: tableId,
      casinoId: this.casinoId,
      currency: this.currency,
    }
    const self = this

    if (self.websocket === null || self.websocket.readyState !== WebSocket.OPEN) {
      delaySubscribersMap.set(tableId, callback)
      return
    }

    subscribersMap.set(tableId, callback)
    self.doWsSend(JSON.stringify(subscribeMessage))
  },

  unsubscribe: function (tableId) {
    subscribersMap.delete(tableId)
  },

  // public
  available: function (casinoId) {
    const availableMessage = {
      type: 'available',
      casinoId: casinoId,
    }

    const self = this
    const jsonSub = JSON.stringify(availableMessage)
    self.doWsSend(jsonSub)
  },

  onWsOpen: function () {
    const self = this

    if (self.onConnect != null) {
      self.onConnect()
    }
  },

  onWsClose: function () {
    const self = this
    if (self.tryToConnect === true) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        self.connect(self.wsUri, self.casinoId)
      }, 5000)
    }
  },

  onWsMessage: function (evt) {
    const self = this
    const data = JSON.parse(evt.data)
    if (self.onMessage != null) {
      self.onMessage(data)
    }
  },

  onWsError: function (evt) {
    console.log('ERROR: ' + evt.data)
  },

  ping: function () {
    const self = this
    const pingMessage = {
      type: 'ping',
      pingTime: Date.now().toString(),
    }
    const jsonSub = JSON.stringify(pingMessage)
    self.doWsSend(jsonSub)
  },

  doWsSend: function (message) {
    const self = this
    self.websocket.send(message)
  },
}
